var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLiveTypoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 12,
    viewBox: "0 0 46 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_9198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7573 9.7368V12H13.8771V0H16.2208V9.7368H20.7561H20.7573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7659 0V12H22.4221V0H24.7659Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2606 0H28.8089L31.7139 9.2232L34.6011 0H37.1661L33.1575 12H30.2525L26.2606 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0001 9.7368V12H38.6442V0H45.9145V2.2632H40.9879V4.818H45.4899V7.0464H40.9879V9.738H45.9989L46.0001 9.7368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21961 7.64424C8.56547 4.97869 8.2244 2.08148 6.45782 1.17312C4.69124 0.264771 2.16811 1.68926 0.822259 4.35481C-0.523594 7.02036 -0.182527 9.91758 1.58405 10.8259C3.35063 11.7343 5.87376 10.3098 7.21961 7.64424Z",
    fill: "#FF3C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_9198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLiveTypoLogo);
export default __webpack_public_path__ + "static/media/ic_live_typo_logo.b2bc7375cd616749de33ff642b19af5f.svg";
export { ForwardRef as ReactComponent };